import styled from 'styled-components';
import Clickable from '@prisjakt/ui-clickable';
import { DiffPercentageCore } from '@prisjakt/ui-product-card/src/styles';
import ProductImage from '@prisjakt/ui-product-image';
import { CompareCheckbox as CompareCheckboxComponent } from '../compare-checkbox';
import { colorUtils, layout } from '@prisjakt/ui-base';

export const CheckboxAndImageColumn = styled.div`
  display: flex;
  align-items: center;
`;

export const ImageContainer = styled.div`
  width: 45px;
  box-sizing: content-box;
`;

export const ListImage = styled(ProductImage)`
  height: 40px;
  width: 40px;
`;

export const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const ProductLink = styled(Clickable)`
  width: 100%;
  display: grid;
  grid-gap: ${layout.measurements.spacingNormal};
  grid-template-columns: auto 1fr auto;
  justify-items: start;
  align-items: center;
  text-align: inherit;
`;

type ListItemProps = {
  isSelectingProducts?: boolean;
};

export const ListItem = styled.li<ListItemProps>`
  border-bottom: 1px solid ${({ theme }) => theme.colors.base200};
  display: block;
  padding: ${layout.spacing.xSmall};
  cursor: pointer;
  position: relative;

  &:hover {
    background: ${p => colorUtils.setRgbaAlpha(p.theme.colors.base800, '0.04')};
  }
`;

export const CompareCheckbox = styled(CompareCheckboxComponent)`
  margin-right: ${layout.spacing.xSmall};
  position: relative;
  top: 0;
  left: 0;
  height: 100%;
`;

export const DiffPercentage = styled(DiffPercentageCore)`
  margin-right: ${layout.spacing.xxSmall};
`;

export const PriceTextWrapper = styled.div`
  align-items: baseline;
  flex-wrap: wrap;
  flex-direction: column;
  text-align: end;
`;

export const PriceText = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: ${layout.measurements.spacingSmall};
`;
